
export function judgeDevice(){
    const ua = navigator.userAgent.toLowerCase();
    if (/ipad|ipod/.test(ua)) {
      return 'ipad';
    } else if (/android|iphone/.test(ua)) {
      return 'mobile';
    }
    return 'pc';
  };